// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2dzr5","load7":"_3k1CU"};